var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "					<div class=\"search-modules__secondaries\">\n						"
    + ((stack1 = lookupProperty(helpers,"block").call(depth0 != null ? depth0 : (container.nullContext || {}),"secondary",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":9,"column":29}}})) != null ? stack1 : "")
    + "\n					</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"search-modules container vanilla-module\" data-component=\"search-modules\">\n	<div class=\"row\">\n		<div class=\"swiper-container\">\n			<div class=\"swiper-wrapper\">\n				"
    + ((stack1 = lookupProperty(helpers,"block").call(alias1,"primary",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":5,"column":25}}})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"content").call(alias1,"secondary",{"name":"content","hash":{},"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":7,"column":31}}}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
    + "			</div>\n		</div>\n	</div>\n</section>\n";
},"useData":true});